"use client";

import { useState } from "react";
import arrowDownIcon from "@/assets/images/kbv-icon-arrow-down.svg";
import leagueDefaultLogo from "@/assets/images/leagues-default.png";

export default function DreamnMatchLeagues({ league, matches = [], render = () => null }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const { name, logo } = league || {};

  return (
    <div className="w-full overflow-hidden transition-all duration-300 ease-in-out border-0">
      <div
        className="flex flex-row justify-start items-center gap-2 cursor-pointer px-3 md:px-4 py-2.5 md:py-3 bg-[var(--theme-primary)] text-[var(--theme-on-primary)] hover:opacity-95 transition-all shadow-sm rounded-t-[10px]"
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <div className="logo shrink-0 w-6 h-6 flex items-center justify-center bg-white rounded-full p-[2px] shadow-sm">
          <img
            className="w-full h-full object-contain rounded-full"
            src={logo || leagueDefaultLogo}
            alt="league logo"
            width={24}
            height={24}
          />
        </div>
        <div className="title text-[15px] md:text-base font-bold text-[var(--theme-on-primary)] truncate">
          {name || "Không xác định"}
        </div>

        <div className="ml-auto px-2">
          <img
            src={arrowDownIcon}
            alt=""
            className={`w-4 h-4 brightness-0 invert opacity-90 transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`}
          />
        </div>
      </div>

      <div
        className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${isExpanded ? "max-h-[9999px]" : "max-h-0"}`}
      >
        {matches.map((match, idx) => render(match, idx, matches.length))}
      </div>
    </div>
  );
}
